var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvertedLogo20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 3.5996,
    x2: 14.468,
    y1: 11.092,
    y2: 11.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCE0F4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DCF2",
    offset: 0.0641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9D2EE",
    offset: 0.1706
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80C2E7",
    offset: 0.3066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47ACDE",
    offset: 0.4649
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E9CD7",
    offset: 0.5674
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0075BE",
    offset: 0.8652
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005B97",
    offset: 0.9944
  })), /*#__PURE__*/React.createElement("path", {
    d: "m9.66 11.97c-0.8 0.1-1.33-0.18-1.77-0.8-0.31 1.01-0.6 1.96-0.89 2.9-0.17 0.55-0.43 1.09-0.48 1.66-0.09 1.06-0.78 1.84-1.06 2.8-0.56-0.15-0.72-0.37-0.7-0.96 0.07-1.72-0.03-3.43-0.49-5.1-0.15-0.55-0.36-1.09-0.56-1.63-0.2-0.53-0.14-0.85 0.31-1.18 2.12-1.53 3.78-3.46 5.09-5.71 0.37-0.64 0.68-0.74 1.35-0.43 1.13 0.51 2.25 1.02 3.37 1.54 0.62 0.29 0.75 0.62 0.53 1.25-0.86 2.46-1.25 4.98-1.04 7.59 0.05 0.57-0.12 0.85-0.62 1-2.24 0.71-4.14 1.99-5.83 3.6-0.42 0.4-0.68 0.44-1.22 0.17 0.16-0.35 0.35-0.69 0.47-1.06 0.33-1.06 1.16-1.82 1.7-2.75 0.59-0.95 1.2-1.87 1.84-2.89zm1.15-1.79c-0.01-0.77-0.62-1.38-1.4-1.38-0.77 0-1.4 0.62-1.4 1.39-0.01 0.79 0.64 1.42 1.42 1.41 0.78-0.02 1.39-0.64 1.38-1.42z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.29 0.27c0.2 0.07 0.35 0.11 0.48 0.17 1.89 0.87 3.78 1.73 5.67 2.6 0.47 0.23 0.56 0.48 0.35 0.96-0.47 1.07-0.55 1.09-1.58 0.61-1.64-0.76-3.29-1.52-4.94-2.27-0.97-0.44-1-0.5-0.55-1.48 0.05-0.1 0.08-0.22 0.16-0.3 0.12-0.11 0.28-0.2 0.41-0.29z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.19 12.36c-0.71 1.11-1.41 2.22-2.12 3.33-0.03-0.02-0.07-0.03-0.11-0.05 0.15-0.37 0.26-0.76 0.46-1.1 0.41-0.7 0.86-1.37 1.29-2.06 0.12-0.19 0.23-0.34 0.48-0.12z",
    fill: "#B9E5FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.34 9.53c0.48 0.44 0.48 1.1-0.01 1.54-0.47 0.43-1.12 0.38-1.54-0.12 1.19 0.14 1.61-0.42 1.55-1.42z",
    fill: "#B9E5FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertedLogo20);
export default __webpack_public_path__ + "static/media/ConvertedLogo20.3ebcba4259b054ac6b9d4510ae5f9f9e.svg";
export { ForwardRef as ReactComponent };